<!--
* @Author: DY
* @Date: 2020-05-27 14:52:13
* @Description: '当日产量'
-->
<template>
    <div class="sameDayYield">
        <div class="head">
            <div class="time">
                <div class="startTime iconfont iconshijian">
                    <input
                        type="text"
                        v-model="startTime"
                        readonly
                        @click="startTimePicker = true"
                    >
                </div>
                <span>-</span>
                <div class="endTime iconfont iconshijian">
                    <input
                        type="text"
                        v-model="endTime"
                        readonly
                        @click="endTimePicker = true"
                    >
                </div>
            </div>
            <div class="btns">
                <template v-for="(item,index) in timeSlot">
                    <van-button
                        :key="index"
                        type="default"
                        :class="{active: timeSlotIndex == index}"
                        @click="selectTimePeriod(index, item)"
                    >
                        {{ item.name }}
                    </van-button>
                </template>
            </div>
        </div>
        <div class="statisticalData">
            <div>
                <h3>{{ totalOutputStatistics.deliver_volume }}</h3>
                <p>生产方量(方)</p>
            </div>
            <div>
                <h3>{{ totalOutputStatistics.adjusted_sign_volume }}</h3>
                <p>发货方量(方)</p>
            </div>
            <div>
                <h3>{{ totalOutputStatistics.adjusted_overage_volume }}</h3>
                <p>盘盈方量(方)</p>
            </div>
        </div>
        <div class="split"></div>
        <div class="productionStatistics">
            <h4>混凝土产量统计</h4>
            <table>
                <thead>
                    <tr>
                        <th>站点</th>
                        <th>生产方量(方)</th>
                        <th>发货方量(方)</th>
                        <th>盘盈方量(方)</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item,index) in productionStatisticsData">
                        <tr :key="index">
                            <th>{{ item.station_name }}</th>
                            <td>{{ item.adjusted_sign_volume }}</td>
                            <td>{{ item.deliver_volume }}</td>
                            <td>{{ item.adjusted_overage_volume }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="split"></div>
        <div class="structuralStatistics">
            <h4>产品结构统计</h4>
            <div id="barChart"></div>
        </div>
        <!-- 开始时间 -->
        <van-popup
            v-model="startTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="startCurrentDate"
                type="datetime"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 结束时间 -->
        <van-popup
            v-model="endTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="endCurrentDate"
                type="datetime"
                title="选择年月日"
                @confirm="endConfirmData"
                @cancel="endTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import util from '@/utils/util';
export default {
    name: 'same-day-yield',
    components: {},
    props: {},
    data() {
        return {
            // 开始时间
            startTime: '',
            // 结束时间
            endTime: '',
            // 开始时间弹出层
            startTimePicker: false,
            // 结束时间弹出层
            endTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 结束时间默认日期
            endCurrentDate: new Date(),
            timeSlot: [{
                name: '上一日',
                val: 1,
            }, {
                name: '本日',
                val: 2,
            }, {
                name: '本月',
                val: 3,
            }, {
                name: '上月',
                val: 4,
            }],
            // 时间段下标
            timeSlotIndex: 1,
            // 总产量统计数据
            totalOutputStatistics: {
                deliver_volume: 0,
                adjusted_sign_volume: 0,
                adjusted_overage_volume: 0,
            },
            // 产量统计数据
            productionStatisticsData: [],
            // 结构统计数据
            structuralStatisticsData: [],
        };
    },
    watch: {},
    computed: {},
    created() {
        // 开始时间
        this.startTime = util.currentTimeFormat('yyyy-MM-dd') + ' 06:00:00';
        this.startCurrentDate = new Date(this.startTime);
        // 结束时间
        this.endTime = util.timeFormat(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd') + ' 06:00:00';
        this.endCurrentDate = new Date(this.endTime);
        // 获取产量统计数据
        this.getProductionStatistics();
        // 获取结构统计数据
        this.getStructuralStatistics();
    },
    mounted() {},
    methods: {
        // 确认选择开始时间
        startConfirmData(val) {
            this.startCurrentDate = val;// 开始时间默认日期
            this.startTime = util.timeFormat(val, 'yyyy-MM-dd HH:mm:ss');
            this.timeSlotIndex = null;
            this.startTimePicker = false;
            // 获取产量统计数据
            this.getProductionStatistics();
            // 获取结构统计数据
            this.getStructuralStatistics();
        },
        // 确认选择结束时间
        endConfirmData(val) {
            this.timeSlotIndex = null;
            this.endCurrentDate = val;// 结束时间默认日期
            this.endTimePicker = false;
            this.endTime = util.timeFormat(val, 'yyyy-MM-dd HH:mm:ss');
            // 获取产量统计数据
            this.getProductionStatistics();
            // 获取结构统计数据
            this.getStructuralStatistics();
        },
        // 选择时间段
        selectTimePeriod(index, data) {
            this.timeSlotIndex = index;
            if (data.val === 1) {
                // 前一天
                const day = new Date();
                day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
                this.startTime = util.timeFormat(day, 'yyyy-MM-dd') + ' 06:00:00';
                this.endTime = util.currentTimeFormat('yyyy-MM-dd') + ' 06:00:00';
            } else if (data.val === 2) {
                // 当天
                this.startTime = util.currentTimeFormat('yyyy-MM-dd') + ' 06:00:00';
                this.endTime = util.timeFormat(new Date(new Date().getTime() + 24 * 60 * 60 * 1000), 'yyyy-MM-dd') + ' 06:00:00';
            } else if (data.val === 3) {
                // 本月
                this.startTime = this.getCurrentMonth(this.formatDate()).startDateTime + ' 06:00:00';
                this.endTime = this.getCurrentMonth(this.formatDate()).endDateTime + ' 06:00:00';
            } else if (data.val === 4) {
                // 上月
                this.startTime = this.getLastMonth(this.formatDate()).startDateTime + ' 06:00:00';
                this.endTime = this.getLastMonth(this.formatDate()).endDateTime + ' 06:00:00';
            }
            // 获取产量统计数据
            this.getProductionStatistics();
            // 获取结构统计数据
            this.getStructuralStatistics();
        },

        // 获取产量统计数据
        async getProductionStatistics() {
            this.productionStatisticsData = [];
            await this.$axios
                .get('/interfaceApi/sale/accounts/get_production_station?'
                    + `startDate=${this.startTime}&endDate=${this.endTime}`
                )
                .then(res => {
                    if (res && res.length > 0) {
                        res.forEach(item => {
                            if (item.station_id === '0') {
                                this.totalOutputStatistics = item;
                            } else {
                                this.productionStatisticsData.push(item);
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },

        // 获取结构统计数据
        async getStructuralStatistics() {
            await this.$axios
                .get('/interfaceApi/sale/accounts/get_production_label?'
                    + `startDate=${this.startTime}&endDate=${this.endTime}`
                )
                .then(res => {
                    const chartData = {
                        yAxisData: [],
                        productionVolume: [],
                        salesVolume: [],
                    };
                    if (res && res.length > 0) {
                        res.forEach(item => {
                            chartData.yAxisData.push(item.strength_grade_name);
                            chartData.productionVolume.push(item.deliver_volume);
                            chartData.salesVolume.push(item.adjusted_sign_volume);
                        });
                    }
                    this.initTransverseChart(chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },

        // 时间格式处理
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },

        // 获取上个月时间段
        getLastMonth(value) {
            const returnData = {
                startDateTime: '',
                endDateTime: '',
            };
            if (value === '' || value === 'undefined') {
                return value;
            }
            // 获取上个月时间
            const nowdays = new Date(value);
            let year = nowdays.getFullYear();
            let month = nowdays.getMonth();
            if (month === 0) {
                month = 12;
                year = year - 1;
            }
            if (month < 10) {
                month = '0' + month;
            }
            const yDate = new Date(year, month, 0);
            returnData.startDateTime = year + '-' + month + '-01';
            returnData.endDateTime = year + '-' + month + '-' + yDate.getDate();

            return returnData;
        },

        // 获取本月时间段
        getCurrentMonth(value) {
            const returnData = {
                startDateTime: '',
                endDateTime: '',
            };
            if (value === '' || value === 'undefined') {
                return value;
            }
            const nowdays = new Date(value);
            const year = nowdays.getFullYear();
            let month = nowdays.getMonth() + 1;
            if (month === 11) {
                month = 12;
            }
            if (month < 10) {
                month = '0' + month;
            }
            const yDate = new Date(year, month, 0);
            returnData.startDateTime = year + '-' + month + '-01'; // 上个月第一天
            returnData.endDateTime = year + '-' + month + '-' + yDate.getDate(); // 上个月最后一天

            return returnData;
        },

        // 横向柱图
        initTransverseChart(data) {
            const myChart = this.$echarts.init(document.getElementById('barChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                legend: {
                    data: ['生产方量', '发货方量'],
                },
                grid: {
                    top: '30',
                    left: '50',
                    right: '30',
                    bottom: '20',
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: '#979EA7',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 12,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: true,
                        lineStyle: {
                            color: '#E5E9ED',
                            type: 'dashed',
                        },
                    },
                },
                yAxis: {
                    type: 'category',
                    data: data.yAxisData,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: '#979EA7',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 12,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: false,
                        lineStyle: {
                            color: '#E5E9ED',
                            type: 'dashed',
                        },
                    },
                },
                series: [
                    {
                        name: '生产方量',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 1, 0,
                                    [
                                        { offset: 0, color: '#DCC129' }, // 柱图渐变色
                                        { offset: 1, color: '#F2E341' }, // 柱图渐变色
                                    ]
                                ),
                            },
                        },
                        data: data.productionVolume,
                    },
                    {
                        name: '发货方量',
                        type: 'bar',
                        itemStyle: {
                            normal: {
                                color: new window.$globalHub.$echarts.graphic.LinearGradient(
                                    0, 0, 1, 0,
                                    [
                                        { offset: 0, color: '#3E79C5' }, // 柱图渐变色
                                        { offset: 1, color: '#55A7FE' }, // 柱图渐变色
                                    ]
                                ),
                            },
                        },
                        data: data.salesVolume,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>

<style scoped lang="stylus">
.sameDayYield
    height 100%
    >div
        padding 15rpx
    .head
        border-bottom 1px solid #F0F0F0
        .time
            display flex
            align-items center
            justify-content center
            height 36rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            margin-bottom 10rpx
            padding 0 0.2rem
            >div
                position relative
                overflow hidden
                padding-left 10rpx
                display flex
                align-items center
                &:before
                    color #979EA7
                    font-size 14rpx
                    line-height 36rpx
                    left 0
                    position absolute
                input
                    width 100%
                    height 100%
                    border none
                    text-align center
                    padding-left 3rpx
                    font-size 13rpx

            >span
                width 20rpx
                line-height 34rpx
                text-align center
                color #979EA7
        .btns
            display flex
            .van-button
                flex 1
                width 70rpx
                height 30rpx
                line-height 28rpx
                margin 0 5rpx
                padding 0
                font-size 12rpx
                color #666666
                border 1px solid #D7D7D7
                border-radius 4rpx
                box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 0.2)
                &:first-child
                    margin-left 0
                &:last-child
                    margin-right 0
                &.active
                    background #3495FB
                    border-color #0E84FF
                    color #fff
                    box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 1)
    .statisticalData
        display flex
        height 73rpx
        display flex
        padding 14rpx 15rpx
        >div
            flex 1
            text-align center
            margin 0 4rpx
            &:nth-of-type(1)
                background rgba(85, 136, 241, 0.06)
                margin-left 0
                h3
                    color #5588F1
            &:nth-of-type(2)
                background rgba(33, 189, 204, 0.06)
                h3
                    color #5588F1
            &:nth-of-type(3)
                background rgba(255, 248, 243, 1)
                margin-right 0
                h3
                    color #FA8639
        h3
            font-size 16rpx
            line-height 26rpx
        p
            font-size 12rpx
            line-height 13rpx
            color #979EA7
    .split
        background #F0F0F0
        height 15rpx
        padding 0
    .productionStatistics
        h4
            font-size 16rpx
            margin-bottom 15rpx
        table
            width 100%
            th,td
                font-size 13rpx
                height 40rpx
                width 85rpx
                text-align center
            th
                border 1px solid #DEE3EF
                background #EBF0FC
                color #333333
            tr
                &:nth-of-type(1)
                    th
                        border 1px solid #DEE3EF
                        background #EBF0FC
                        color #101077
                    td
                        background rgba(85, 136, 241, 0.04)
                        color #5588F1
                &:nth-of-type(2)
                    th
                        border 1px solid #EFE5DE
                        background #FCF2EB
                        color #823802
                    td
                        background rgba(250, 132, 54, 0.04)
                        color #FA8436
                &:nth-of-type(3)
                    th
                        border 1px solid #DEEEEF
                        background #DFFAFB
                        color #02767D
                    td
                        background rgba(33, 189, 204, 0.04)
                        color #40C6D3
    .structuralStatistics
        h4
            font-size 16rpx
            margin-bottom 15rpx
        #barChart
            height 234rpx
</style>
